import { createStore } from "vuex";
import themeLayout from "./modules/themeLayout/actionCreator";

export default createStore({
  state: {
    baseUrl: "https://admin.alhamroorhazard.com/",
    notificationsCount: 0,
    unResolvedNotesCount: 0,
    currentUser: JSON.parse(localStorage.getItem("user_data")) || null,
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setNotificationsCount(state, count) {
      state.notificationsCount = count;
    },
    setUnResolvedNotesCount(state, count) {
      state.unResolvedNotesCount = count;
    },
    decrementNotificationsCount(state) {
      if (state.notificationsCount > 0) {
        state.notificationsCount--;
      }
    },
  },
  getters: {
    getNotificationsCount: (state) => state.notificationsCount,
    getUnResolvedNotesCount: (state) => state.unResolvedNotesCount,
    getCurrentUser: (state) => state.currentUser,
  },
  actions: {
    loginUser({ commit }, user) {
      commit("setCurrentUser", user);
    },
    decrementNotificationCount({ commit }) {
      commit("decrementNotificationsCount");
    },
  },
  modules: {
    themeLayout,
  },
});
